import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { SessionCheckerHelper } from "./core/helpers/sessionChecker.helper";
import { AuthenticationServiceImpl } from "./core/http/impl/authentication.service.impl";
import { LocalStorageHelper } from "./core/helpers/local.storage.helper";
import { LOCAL_STORAGE_CONSTANTS } from "./core/constants/local.storage.constants";
import { PageTitleService } from "./base/page-title/page-title.service";
import { environment } from "src/environments/environment";
import { filter, map, mergeMap } from "rxjs/operators";

declare var gtag: (
	arg0: string,
	arg1: string,
	arg2: { page_path: string }
) => void;

@Component({
	selector: "jt-app",
	template: "<router-outlet jtUserActivityChecker></router-outlet>",
	styleUrls: ["./app.component.css"],
	encapsulation: ViewEncapsulation.None,
})
export class JamestownAppComponent implements OnInit {
	constructor(
		public router: Router,
		public activatedRoute: ActivatedRoute,
		public titleService: PageTitleService,
		public sessionCheckerHelper: SessionCheckerHelper,
		public authenticationServiceImpl: AuthenticationServiceImpl,
		public localStorageHelper: LocalStorageHelper,
	) {

		this.router.events.subscribe({
			next: (event: any) => {
				if (event instanceof NavigationEnd) {
					gtag("config", environment.firebaseConfig.idGA, {
						page_path: event.urlAfterRedirects,
					});
				}
			},
		});
	}

	ngOnInit() {
		this.router.events
			.pipe(
				filter((event: any) => event instanceof NavigationEnd),
				map(() => this.activatedRoute),
				map((route) => {
					while (route.firstChild) {
						route = route.firstChild;
					}
					return route;
				}),
				filter((route) => route.outlet === "primary"),
				mergeMap((route) => route.data)
			)
			.subscribe(
				{
					next: (event: any) => {
						this.titleService.setTitle(event["title"])
					}
				}
			);

		this.sessionCheckerHelper.onJwtSessionExpired(() => {
			this.authenticationServiceImpl.closeSession();
			this.localStorageHelper.addItem(
				LOCAL_STORAGE_CONSTANTS.SHOW_EXPIRED_TOKEN_MODAL,
				"true"
			);
		});

		this.sessionCheckerHelper.onInactivityUser(() => {
			this.authenticationServiceImpl.logout().subscribe({
				next: () => {
					this.authenticationServiceImpl.closeSession();
					setTimeout(() => {
						window.location = window.location;
					}, 0);
				}
			});
		});
	}

}
